<template>
  <v-container
    fluid
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-cog-outline
      </v-icon> Digi-Board Settings
    </h2>
    <v-card
      color="#CFD8DC"
      shaped
    >
      <v-container
        fluid
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-card
              color="#eceff1"
              class="my-card-style"
            >
              <v-card-title class="justify-center">
                <h3
                  class="mt-2 my-title-style"
                >
                  Update Settings
                </h3>
              </v-card-title>
              <v-form>
                <v-container class="py-0 mt-2">
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <p
                      v-if="showCreateButton"
                      class="text-left my-alert-style"
                    >
                      No setting found.
                    </p>
                    <v-textarea
                      v-model="digiBoardSettingsDetails"
                      filled
                      background-color="#CFD8DC"
                      auto-grow
                    />
                    <v-btn
                      v-if="!showCreateButton"
                      color="#FF3700"
                      @click="updateDigiBoardSettingsDetails()"
                    >
                      Update
                    </v-btn>
                    <v-btn
                      v-else
                      color="#FF3700"
                      @click="createDigiBoardSettings()"
                    >
                      create
                    </v-btn>
                  </v-col>
                </v-container>
              </v-form>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-card
              color="#eceff1"
              class="my-card-style"
            >
              <v-card-title class="justify-center">
                <h3
                  class="mt-2 my-title-style"
                >
                  Settings Reference
                </h3>
              </v-card-title>
              <v-col
                cols="12"
                class="text-right mt-2"
              >
                <v-textarea
                  v-model="digiBoardSettingsReference "
                  filled
                  background-color="#CFD8DC"
                  auto-grow
                  disabled
                />
              </v-col>
            </v-card>
          </v-col>
        </v-row>
        <centre-spinner
          :loading="loading"
        />
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'DigiBoardSettingsDetails',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        loading: false,
        digiBoardSettingsDetails: {},
        digiBoardSettingsReference: {},
        showCreateButton: false,
      };
    },
    computed: {
      digiboardSettings () {
        return this.$store.getters['digiboards/getDigiBoardSettings'];
      },
    },
    // async mounted () {
    //   await this.fetchDigiBoardSettingsDetails();
    // },
    methods: {
      async fetchDigiBoardSettingsDetails () {
        this.loading = true;
        const digiBoardId = this.$route.params.id;
        await this.$store.dispatch('digiboards/fetchDigiBoardSettingsDetails', digiBoardId)
          .then(response => {
            this.digiBoardSettingsDetails = JSON.stringify(this.digiboardSettings.settings.settings, null, 4);
            this.digiBoardSettingsReference = JSON.stringify(this.digiboardSettings.reference, null, 4);
            if (Object.keys(this.digiboardSettings.settings).length === 0 || this.digiboardSettings.settings.length === 0) {
              this.showCreateButton = true;
            }
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
      },
      createDigiBoardSettings () {
        this.loading = true;
        const digiBoardId = this.$route.params.id;
        const digiBoardSettingsDetails = JSON.parse(this.digiBoardSettingsDetails);
        this.$store.dispatch('digiboards/createDigiBoardSettingsDetails', { settings: { settings: digiBoardSettingsDetails }, digiBoardId: digiBoardId })
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Digi-Board Settings created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.loading = false;
            this.fetchDigiBoardSettingsDetails();
          }).catch(() => {
            this.loading = false;
          });
      },
      updateDigiBoardSettingsDetails () {
        this.loading = true;
        const digiBoardId = this.$route.params.id;
        const settingsId = this.digiboardSettings.settings.id;
        const updatedDigiBoardSettingsDetails = JSON.parse(this.digiBoardSettingsDetails);
        this.$store.dispatch('digiboards/updateDigiBoardSettingsDetails', { settings: { settings: updatedDigiBoardSettingsDetails }, digiBoardId: digiBoardId, settingsId: settingsId })
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Digi-Board Settings updated successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.loading = false;
            this.fetchDigiBoardSettingsDetails();
          }).catch(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
<style scoped>
.my-card-style {
    min-height: 315px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-title-style {
  color: #546e7a;
}
.my-alert-style {
  color:#FF3700;
}
@media (max-width: 960px) {
  .title-style {
    margin-top: -20px;
  }
}
</style>
